import { jsx as _jsx } from "react/jsx-runtime";
import Video from '../video';
import { GallerySlide } from './styles/gallery-slide.styled';
export const GalleryVideoSlide = ({ reference, index, active, videoId, }) => (_jsx(GallerySlide, { "$variant": "video", className: "PONCHO-gallery__slide", id: `${reference}-slide-${index}`, "aria-hidden": !active, children: _jsx("figure", { children: active ? _jsx(Video, { id: videoId }) : null }) }, index));
